import create from "zustand";

const useUpdateDataStore = create((set: any) => ({
    updateData: [],
    setUpdateData: (data: any) => set(() => ({ updateData: data })),
}));

export { useUpdateDataStore };
